import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_COACH_TASKS](state, payload) {
    state.tasks = payload;
  },
  [MutationsType.UPDATE_COACH_TASK](state, payload) {
    let ind = (state.tasks || []).findIndex((task) => task.id === payload.id);
    if (ind >= 0) Vue.set(state.tasks, ind, { ...state.tasks[ind], ...payload });
  },
  [MutationsType.SET_COACH_TASK_TICKETS](state, payload) {
    state.taskTickets = payload;
  },
  [MutationsType.UPDATE_COACH_TASK_TICKET](state, payload) {
    let ind = (state.taskTickets || []).findIndex((task) => task.id === payload.id);
    if (ind >= 0) Vue.set(state.taskTickets, ind, { ...state.taskTickets[ind], ...payload });
  },
  [MutationsType.REMOVE_COACH_TASK_TICKET](state, payload) {
    let ind = (state.taskTickets || []).findIndex((taskTicket) => taskTicket.id === payload.id);
    if (ind >= 0) Vue.delete(state.taskTickets, ind);
  },
};
